@import 'node_modules/xterm/css/xterm';

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
  #start-session-container {
    padding-top: calc(var(--spacer) * 2.25);
    #start-session-title {
      margin-bottom: calc(var(--spacer) * 4.12);
    }
    #authentication-code {
      margin-top: calc(var(--spacer) * 3);
    }
  }

  #terminal-container {
    width: 100%;
    height: 100%;
    min-height: calc(var(--spacer) * 75);

    .terminal {
      width: 100%;
      height: 100%;
      min-height: calc(var(--spacer) * 75);
    }
  }

  #end-session-container {
    padding-top: calc(var(--spacer) * 2.25);

    gz-labeled-content {
      height: auto; // TODO FED
    }
  }
}

.end-session-time-content {
  display: flex;

  .label-box {
    max-width: 270px;

    .label-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: var(--chart-300-icon-buttons);
      margin-bottom: var(--spacer);

      gz-tooltip {
        width: 100%;
      }
    }
  }
  .time-box {
    padding-left: 60px;

    gz-title {
      margin-bottom: var(--spacer);
      line-height: 18px;
    }
  }
}
